import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Grid,
  FormControl,
  TextField,
  Divider,
  Typography,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterDayjsBuddhist } from "./AdapterDayjsBuddhist";
import dayjs from "dayjs";
import "dayjs/locale/th";
import { FormData } from "./MainFormPersonaNewV1";

interface FormLegalEntityProps {
  formData: FormData;
  errors: { [key: string]: boolean };
  // handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFormData: any;
  setErrors: any;
}

const FormLegalEntity: React.FC<FormLegalEntityProps> = ({
  formData,
  errors,
  setErrors,
  setFormData,
}) => {
  const validateCid = (business_full_cid_1: string) => {
    // console.log("Validating CID:", business_full_cid_1);
    return /^[0-9]{13}$/.test(business_full_cid_1);
  };

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
    // }

    // อัปเดต errors

    // if (name === "business_full_cid_1" || name ==="business_full_cid_2") {
    //   if (!validateCid(value)) {
    //     setErrors((prevErrors: any) => ({ ...prevErrors, business_full_cid_1: true }));
    //     setErrors((prevErrors: any) => ({ ...prevErrors, business_full_cid_2: true }));
    //   } else {
    //     setErrors((prevErrors: any) => {
    //       const newErrors = { ...prevErrors };
    //       delete newErrors.business_full_cid_1;
    //       delete newErrors.business_full_cid_2;
    //       return newErrors;
    //     });
    //   }
    // }
    const isValidCID = isValidThaiIdCard(value);
    if (
      name === "business_full_cid_1" ||
      (name === "business_full_cid_2" && value)
    ) {
      setErrors((prevErrors: any) => {
        const newErrors = { ...prevErrors };

        if (!isValidCID) {
          newErrors[name] = true; // Set error if not valid
        } else {
          delete newErrors[name]; // Remove error if valid
        }

        return newErrors;
      });
    } else {
      setErrors((prevErrors: any) => {
        const newErrors = { ...prevErrors };
        // ตรวจสอบว่า value ของฟิลด์นี้มีค่าหรือไม่
        if (value.trim()) {
          delete newErrors[name]; // ถ้ามีค่าให้ลบข้อผิดพลาด
        } else {
          if (name === "business_full_cid_2" && (!value || value === "")) {
            delete newErrors[name];
          } else {
            newErrors[name] = true;
          }
        }
        return newErrors;
      });
    }
  };
  const isValidThaiIdCard = (id: string): boolean => {
    if (!/^[1-9]\d{12}$/.test(id)) return false;

    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(id.charAt(i)) * (13 - i);
    }
    const checkDigit = (11 - (sum % 11)) % 10;

    return checkDigit === parseInt(id.charAt(12));
  };

  return (
    <form>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      {/* หัวข้อข้อมูลนิติบุคคล และฟอร์มกรอกชื่อ นิติบุคคล */}
      <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
        <Grid item xs={12} md={2} sx={{ alignSelf: "flex-start" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            ข้อมูลนิติบุคคล
          </Typography>
        </Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      นิติบุคคล <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกข้อมูลนิติบุคคล 13 หลัก"
                  value={formData.business_name_th}
                  name="business_name_th"
                  onChange={handleFormChange}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^0-9\s]/g, ""); // ให้กรอกเฉพาะตัวเลขเท่านั้น
                  }}
                  inputProps={{
                    maxLength: 13,
                    pattern: "[0-9s]*",
                    inputMode: "numeric",
                  }}
                  error={
                    errors.business_name_th ||
                    formData.business_name_th.length !== 13
                  }
                  helperText={
                    errors.business_name_th ||
                    formData.business_name_th.length !== 13
                      ? "กรุณากรอกข้อมูลนิติบุคคล 13 หลัก"
                      : ""
                  }
                />
              </FormControl>
            </Grid>
          </Grid>

          {/* ฟอร์มกรอกชื่อ1 */}
          <Grid container spacing={2} sx={{ mt: 0, rowGap: 1 }}>
            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      ชื่อ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกชื่อ"
                  value={formData.business_firstname_th_1}
                  name="business_firstname_th_1"
                  // onChange={handleFormChange}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[\u0E01-\u0E4C\u0E5A-\u0E5BA-Za-z]*$/;
                    if (regex.test(inputValue)) {
                      handleFormChange(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  error={errors.business_firstname_th_1}
                  helperText={
                    errors.business_firstname_th_1 ? "กรุณากรอกชื่อ" : ""
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      นามสกุล <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกนามสกุล"
                  value={formData.business_lastname_th_1}
                  name="business_lastname_th_1"
                  // onChange={handleFormChange}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[\u0E01-\u0E4C\u0E5A-\u0E5BA-Za-z\s]*$/;
                  
                    if (regex.test(inputValue)) {
                      // เช็คจำนวน space
                      const spaceCount = (inputValue.match(/\s/g) || []).length;
                  
                      // ห้ามเริ่มต้นด้วย space และspace แค่ 1 ครั้ง หลังจากมีตัวอักษรแล้ว
                      if (
                        !inputValue.startsWith(" ") &&        // ห้ามกด space เป็นตัวแรก
                        (spaceCount <= 1 || inputValue === "") // space ได้ไม่เกิน 1 ครั้ง
                      ) {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>);
                      }
                    }
                  }}
                  
                  error={errors.business_lastname_th_1}
                  helperText={
                    errors.business_lastname_th_1 ? "กรุณากรอกนามสกุล" : ""
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      เลขประจำตัวประชาชน <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกเลขประจำตัวประชาชน"
                  value={formData.business_full_cid_1}
                  name="business_full_cid_1"
                  onChange={handleFormChange}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^0-9]/g, ""); // ให้กรอกเฉพาะตัวเลขเท่านั้น
                  }}
                  error={errors.business_full_cid_1}
                  helperText={
                    errors.business_full_cid_1
                      ? "กรุณากรอกเลขประจำตัวประชาชน"
                      : ""
                  }
                  inputProps={{
                    maxLength: 13,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={<span>ชื่อ</span>}
                  placeholder="กรุณากรอกชื่อ"
                  value={formData.business_firstname_th_2}
                  name="business_firstname_th_2"
                  // onChange={handleFormChange}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[\u0E01-\u0E4C\u0E5A-\u0E5BA-Za-z]*$/; // ไม่รวม space
                    if (regex.test(inputValue)) {
                      handleFormChange(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  // error={errors.business_firstname_th_2}
                  // helperText={errors.business_firstname_th_2 ? "กรุณากรอกชื่อ" : ""}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={<span>นามสกุล</span>}
                  placeholder="กรุณากรอกนามสกุล"
                  value={formData.business_lastname_th_2}
                  name="business_lastname_th_2"
                  // onChange={handleFormChange}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[\u0E01-\u0E4C\u0E5A-\u0E5BA-Za-z\s]*$/;
                  
                    if (regex.test(inputValue)) {
                      // เช็คจำนวน space
                      const spaceCount = (inputValue.match(/\s/g) || []).length;
                      // ห้ามเริ่มต้นด้วย space และspace แค่ 1 ครั้ง หลังจากมีตัวอักษรแล้ว
                      if (
                        !inputValue.startsWith(" ") &&        // ห้ามกด space เป็นตัวแรก
                        (spaceCount <= 1 || inputValue === "") // space ได้ไม่เกิน 1 ครั้ง
                      ) {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>);
                      }
                    }
                  }}
                  

                  // error={errors.business_lastname_th_2}
                  // helperText={errors.business_lastname_th_2 ? "กรุณากรอกนามสกุล" : ""}
                  // inputProps={{
                  //   maxLength: 10,
                  //   pattern: "[0-9]*",
                  //   inputMode: "numeric",
                  // }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={<span>เลขประจำตัวประชาชน</span>}
                  placeholder="กรุณากรอกเลขประจำตัวประชาชน"
                  value={formData.business_full_cid_2}
                  name="business_full_cid_2"
                  onChange={handleFormChange}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^0-9\-]/g, ""); // ให้กรอกเฉพาะตัวเลขเท่านั้น
                  }}
                  error={errors.business_full_cid_2}
                  helperText={
                    errors.business_full_cid_2
                      ? "กรุณากรอกเลขประจำตัวประชาชน"
                      : ""
                  }
                  inputProps={{
                    maxLength: 13,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      เป็นนิติบุคคลประเภท{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกประเภทนิติบุคคล"
                  value={formData.business_type}
                  name="business_type"
                  // onChange={handleFormChange}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[^\s]*$/; // regex ตรวจสอบว่าไม่มีช่องว่าง (space)

                    // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                    if (regex.test(inputValue)) {
                      handleFormChange(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  error={errors.business_type}
                  helperText={
                    errors.business_type ? "กรุณากรอกประเภทนิติบุคคล" : ""
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjsBuddhist}
                  adapterLocale="th"
                >
                  <DatePicker
                    label={
                      <span>
                        จดทะเบียนเมื่อ <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    value={
                      formData.business_create_date
                        ? dayjs(formData.business_create_date)
                        : null
                    }
                    onChange={(newValue) => {
                      if (newValue) {
                        setFormData((prev: any) => ({
                          ...prev,
                          business_create_date: newValue,
                        }));
                      }
                    }}
                    format="DD/MM/YYYY"
                    disableFuture
                    slots={{ textField: TextField }}
                    localeText={{ toolbarTitle: "กรุณาเลือกวันที่" }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: "outlined",
                        size: "medium",
                        placeholder: "กรุณากรอกวันที่จดทะเบียน",
                        sx: {
                          backgroundColor: "#ffffff",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "4px",
                            backgroundColor: "#ffffff",
                          },
                        },
                        error: errors.business_create_date,
                        helperText: errors.business_create_date
                          ? "กรุณากรอกวันที่จดทะเบียน"
                          : "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={5}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      เลขทะเบียน <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกเลขทะเบียน 13 หลัก"
                  value={formData.business_code}
                  name="business_code"
                  onChange={handleFormChange}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^0-9]/g, ""); // ให้กรอกเฉพาะตัวเลขเท่านั้น
                  }}
                  inputProps={{
                    maxLength: 13,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                  error={
                    errors.business_code ||
                    formData.business_code?.length !== 13
                  }
                  helperText={
                    errors.business_code ||
                    formData.business_code?.length !== 13
                      ? "กรุณากรอกเลขทะเบียน 13 หลัก"
                      : ""
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default FormLegalEntity;
